<template>
<div class="crop-box">
</div>
</template>


<script>
import Croppie from 'croppie';
export default {
  props: ["src", "crop"],
  watch: {
    src: {
      handler() {
        this.bind();
      }, immediate: true,
    }
  },
  methods: {
    async bind() {
      var result=await this.croppie && this.croppie.bind({
        url: this.src,
      });
    },
  },
  mounted() {
    this.croppie=new Croppie(this.$el, {
      viewport: {width: 300, height: 169, type: 'square'},
      enforceBoundary: true,
    });
    var croppie=this.croppie;
    this.bind();
    this.$el.addEventListener("update", async (ev)=>{
      var blob=await croppie.result({
        type: "blob", 
        size: {width: 1920, height: 1080}, 
        format: "jpeg"});
      this.$emit('update:crop', blob);
    })
  },
}
</script>
